import type { ObjectValues } from '@/types';

export const QUERY_KEYS = {
  GET_REPORT: 'getReport',
  SEND_REQUEST: 'sendRequest',
} as const;

export type QueryKeys = ObjectValues<typeof QUERY_KEYS>;
